import { Fetch } from "water-rest/src/fetch/Fetch";
import { FiasSearchResult } from "water-rest/src/model/fias/SearchResult";

const addressReductions = [
    'респ.', 'край', 'обл.', 'г.ф.з.', 'обл.', 'окр.', 'м.р-н', 'г.о.', 'г.п.', 'с.п.', 'вн.р-н', 'вн.тер.г.', 'пос.', 'р-н',
    'с/с', 'г.', 'пгт.', 'рп.', 'кп.', 'гп.', 'п.', 'аал', 'арбан', 'аул', 'в-ки', 'г-к', 'з-ка', 'п-к', 'киш.', 'п. ст.',
    'п. ж/д ст.', 'ж/д бл-ст', 'ж/д б-ка', 'ж/д в-ка', 'ж/д к-ма', 'ж/д к-т', 'ж/д пл-ма', 'ж/д пл-ка', 'ж/д п.п.',
    'ж/д о.п.', 'ж/д рзд.', 'ж/д ст.', 'м-ко', 'д.', 'с.', 'сл.', 'ст.', 'ст-ца', 'у.', 'х.', 'рзд.', 'зим.', 'б-г', 'вал',
    'ж/р', 'зона', 'кв-л', 'мкр.', 'ост-в', 'парк', 'платф.', 'п/р', 'р-н', 'сад', 'сквер', 'тер.', 'СНО', 'ОНО', 'ДНО',
    'СНТ', 'ОНТ', 'ДНТ', 'СПК', 'ОПК', 'ДПК', 'СНП', 'ОНП', 'ДНП', 'ТСН', 'ГСК', 'ус.', 'тер.ф.х.', 'ю.', 'ал.', 'б-р',
    'взв.', 'взд.', 'дор.', 'ззд.', 'км', 'к-цо', 'коса', 'лн.', 'мгстр.', 'наб.', 'пер-д', 'пер.', 'пл-ка', 'пл.', 'пр-д', 
    'пр-к', 'пр-ка', 'пр-лок', 'пр-кт', 'проул.', 'рзд.', 'ряд',  'с-р',  'с-к',  'сзд.',  'тракт',  'туп.',  'ул.',  'ш.',
    'влд.',  'г-ж',  'д.',  'двлд.',  'зд.',  'з/у',  'кв.',  'ком.',  'подв.',  'кот.',  'п-б',  'к.',  'офис',  'пав.',
    'помещ.',  'раб.уч.',  'скл.',  'coop.',  'стр.',  'зал',  'цех', 'кор.'
]

const searchQuery = (address: string): Promise<Array<number>> => {
  return new Promise<Array<number>>((resolve, reject) => {
    Fetch.get<Array<any>>(`https://nominatim.openstreetmap.org/search?q=${address}&format=json&addressdetails=1&limit=1`)
      .then((response: Array<any>) => {
        if (response.length === 0) reject();

        const firstObject: any = response[0];
        if (!firstObject.lat || !firstObject.lon) reject();

        resolve([firstObject.lat, firstObject.lon]);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const searchByFiasAddress = (address: FiasSearchResult): Promise<Array<number>> => {
  if (address == null || address.shortAddress == null) return Promise.reject();
  return searchQuery(
    address.shortAddress
      .split(" ")
      .reduce((acc: string[], val: string): string[] => (addressReductions.includes(val) ? acc : [...acc, val]), [])
      .join(" ")
  );
};

export const searchAddressByCoords = (coords: Array<number>): Promise<any> => {
  return new Promise<any>((resolve, reject) => {
    if (coords && coords.length) {
      Fetch.get<any>(`https://nominatim.openstreetmap.org/reverse?lat=${coords[0]}&lon=${coords[1]}&format=json&extratags=1`)
        .then((res: any) => {
          if (res.error) reject()
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject()
    }
  })
}
